import { React, _ } from '../../../lib';
import { Alerts } from '../../component-main';
import { svrtsRequest } from '../../svrts-interface';
import { HelpTooltip } from '../help';
import { readDynamic } from './types';
export const runLLMFormFill = (input) => {
    if (input.manager.disableFormFill) {
        console.log('Form fill is disabled');
        return;
    }
    const fields = _.fromPairs(_.map(input.manager.fields, (field, key) => [
        key,
        {
            originalValue: input.manager.defaultState[key],
            value: input.currentState[key],
            type: getFieldType(readDynamic(field.llmInfo, input.currentState)),
        },
    ]));
    svrtsRequest({
        data: {
            funcID: [0, 50],
            description: input.description ?? null,
            request: input.request,
            fields: fields,
        },
        no: data => {
            Alerts.Alert({ msg: data.message });
        },
        yes: data => {
            input.yes(data.values);
        },
    });
};
const getFieldType = (llmInfo) => {
    if (!llmInfo) {
        return null;
    }
    return {
        type: llmInfo.stringifiedType,
        description: llmInfo.description,
        enum: null,
        enumsAreComplete: null,
        ...(llmInfo.enums && {
            enum: llmInfo.enums,
            enumsAreComplete: llmInfo.enumsAreComplete,
        }),
    };
};
export const FormFillButton = (props) => props.manager.disableFormFill ? (React.createElement(React.Fragment, null)) : (React.createElement(HelpTooltip, { title: "Click to edit this form using your voice in natural language. Note you can use the right Ctrl key (after clicking somewhere in the form) to do this quickly with push-to-talk" },
    React.createElement("button", { type: "button", className: "opacity-50 hover:opacity-100", onClick: () => {
            props.manager.startTranscriptionFormFill({
                currentState: props.currentState,
                editBeforeSending: false,
                setState: props.setState,
                formPrompt: props.formPrompt,
                voicePrompt: props.voicePrompt,
                containingElement: props.containingElement,
            });
        } },
        React.createElement("img", { src: "/static/img/i8/sparkles.svg", className: "w-4 h-4" }))));
//# sourceMappingURL=llm-fill.js.map